module.exports = "/_next/static/images/7e17cc70274ad9efc2341f099d20f456-website-thumb-large.jpg";